// @ts-nocheck
import { BasicShape } from "../BasicShape";
import { convertWebGLToCanvas2DPoint, findLinesIntersection, g, getMid, getSelectBoundaryRectangle, getTriangulatedVerticesByTwoPoints, isPointInsideFrame, isinSelectBoundaryLine } from "../../shared/common";
import { Point } from "../Point";
import { Line } from "./Line";
import { mat3 } from "gl-matrix";
import { transformPointByMatrix3 } from "../../shared/common";
import { s } from '../../shared/globalState/settings';
import { Vector } from "../Vector";
// --- rxjs
import { ObjectTypes } from "../../shared/enums";
import { Grip } from '../snaps/Grip';
import { RouteCrucialPoints } from "../../shared/types";


export class Rectangle extends BasicShape {
    isSelected: boolean;

    private _width: number;
    private _height: number;

    private _p1: Point;
    private _p2: Point;
    private _p3: Point;
    private _p4: Point;
    m1: Point;
    m2: Point;
    m3: Point;
    m4: Point;
    center: Point;

    private _thickness: number;
    type: string;
    color: number[];
    
    saved: Float32Array;
    
    /**
     * Класс фигуры Прямоугольник.
     * Поля width и height используются только при первой отрисовке прямоугольника, 
     * на их основе вычисляются позиции точек p2, p3, p4. Далее поля width и height не используются
     */
    get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
    }
    get p1() {
        return this._p1;
    }
    set p1(point) {
        this._p1 = point.clone();
        this.updateMid();
    }
    get p2() {
        return this._p2;
    }
    set p2(point) {
        this._p2 = point.clone();
        this.updateMid();
    }
    get p3() {
        return this._p3;
    }
    set p3(point) {
        this._p3 = point.clone();
        this.updateMid();
    }
    get p4() {
        return this._p4;
    }
    set p4(point) {
        this._p4 = point.clone();
        this.updateMid();
    }

    set thickness(value) {
        this._thickness = value;
        this.updateMid();
    }
    get thickness() {
        return this._thickness;
    }

    constructor(p1: Point, p2: Point, p3: Point, p4: Point, width, height, color: number[], thickness) {
        super();

        this.type = ObjectTypes.rectangle;
        this._p1 = p1 ? p1.clone() : null;
        this._p2 = p2 ? p2.clone() : null;
        this._p3 = p3 ? p3.clone() : null;
        this._p4 = p4 ? p4.clone() : null;
        this.width = width;
        this.height = height;
        this.color = [...color];
        this._thickness = thickness;

        this.updateMid();
        this.updateCenter();
        this.rtype = undefined;
    }

    updateMid() {
        this.m1 = getMid(this.p1, this.p2);
        this.m2 = getMid(this.p2, this.p3);
        this.m3 = getMid(this.p3, this.p4);
        this.m4 = getMid(this.p4, this.p1);

        // ********* обновление сохранённых вершин **********
        this.saved = this.getVertices();

    }

    updateCenter() {
        const dx = (this.p2.x - this.p1.x) / 2;
        const dy = (this.p3.y - this.p2.y) / 2;
        const x = this.p1.x + dx;
        const y = this.p1.y + dy;
        this.center = new Point(x, y);
    }

    getVertices() {
        var verts1 = getTriangulatedVerticesByTwoPoints(this.p1, this.p2, this.thickness);
        var verts2 = getTriangulatedVerticesByTwoPoints(this.p2, this.p3, this.thickness);
        var verts3 = getTriangulatedVerticesByTwoPoints(this.p3, this.p4, this.thickness);
        var verts4 = getTriangulatedVerticesByTwoPoints(this.p4, this.p1, this.thickness);

        return new Float32Array([
            ...verts1,
            ...verts2,
            ...verts3,
            ...verts4]);

    }

    getTriangulatedVertices() {
        // Calculate the vectors along the rectangle edges
        let vectors = [];
        for (let i = 0; i < 4; i++) {
            let dx = this['p' + ((i % 4) + 1)].x - this['p' + (((i + 1) % 4) + 1)].x;
            let dy = this['p' + ((i % 4) + 1)].y - this['p' + (((i + 1) % 4) + 1)].y;
            vectors.push({ dx, dy });
        }

        // Calculate the normalized perpendicular vectors
        let normals = [];
        for (let i = 0; i < 4; i++) {
            let length = Math.hypot(vectors[i].dx, vectors[i].dy);
            let nx = vectors[i].dy / length;  // Normalized perpendicular vector x
            let ny = -vectors[i].dx / length; // Normalized perpendicular vector y
            normals.push({ nx, ny });
        }

        // Calculate the offset points for the rectangle corners
        let width = this.thickness;
        let offsetPoints = [];
        for (let i = 0; i < 4; i++) {
            offsetPoints.push({
                x: this['p' + ((i % 4) + 1)].x + normals[i].nx * width / 2,
                y: this['p' + ((i % 4) + 1)].y + normals[i].ny * width / 2
            });
        }

        // Return the coordinates of the 8 triangles
        return new Float32Array([
            // First triangle
            this.p1.x, this.p1.y,
            offsetPoints[0].x, offsetPoints[0].y,
            offsetPoints[1].x, offsetPoints[1].y,

            // Second triangle
            this.p1.x, this.p1.y,
            offsetPoints[1].x, offsetPoints[1].y,
            this.p2.x, this.p2.y,

            // Third triangle
            this.p2.x, this.p2.y,
            offsetPoints[1].x, offsetPoints[1].y,
            offsetPoints[2].x, offsetPoints[2].y,

            // Fourth triangle
            this.p2.x, this.p2.y,
            offsetPoints[2].x, offsetPoints[2].y,
            this.p3.x, this.p3.y,

            // Fifth triangle
            this.p3.x, this.p3.y,
            offsetPoints[2].x, offsetPoints[2].y,
            offsetPoints[3].x, offsetPoints[3].y,

            // Sixth triangle
            this.p3.x, this.p3.y,
            offsetPoints[3].x, offsetPoints[3].y,
            this.p4.x, this.p4.y,

            // Seventh triangle
            this.p4.x, this.p4.y,
            offsetPoints[3].x, offsetPoints[3].y,
            offsetPoints[0].x, offsetPoints[0].y,

            // Eighth triangle
            this.p4.x, this.p4.y,
            offsetPoints[0].x, offsetPoints[0].y,
            this.p1.x, this.p1.y
        ]);
    }

    getVerticesArray() {
        return [
            this.p1.x, this.p1.y,
            this.p2.x, this.p2.y,
            this.p3.x, this.p3.y,
            this.p4.x, this.p4.y,
        ];
    }

    getVerticesPixels(scale) {
        const p1 = convertWebGLToCanvas2DPoint(this.p1, s.canvasWidth, s.canvasHeight);
        const p2 = convertWebGLToCanvas2DPoint(this.p2, s.canvasWidth, s.canvasHeight);
        const p3 = convertWebGLToCanvas2DPoint(this.p3, s.canvasWidth, s.canvasHeight);
        const p4 = convertWebGLToCanvas2DPoint(this.p4, s.canvasWidth, s.canvasHeight);
        return [
            p1.x / scale, p1.y / scale,
            p2.x / scale, p2.y / scale,
            p3.x / scale, p3.y / scale,
            p4.x / scale, p4.y / scale,
        ];

    }

    updatePoints() {
        /**
         * Эта функция нужна для того, чтобы точка p1 оставалась всегда в верхнем-левом углу.
         * Соответственно обновляются и остальные точки.
         * Функцию нужно выполнять во всех операциях с прямоугольником,
         * где меняются позиции точек - это поворот и зеркальное отображение
         */
        const array = [this.p1, this.p2, this.p3, this.p4];

        const minX = Math.min(...array.map(p => p.x));

        const minY = Math.min(...array.map(p => p.y));

        const maxX = Math.max(...array.map(p => p.x));
        const maxY = Math.max(...array.map(p => p.y));

        const newP1 = new Point(minX, minY);
        const newP2 = new Point(maxX, minY);
        const newP3 = new Point(maxX, maxY);
        const newP4 = new Point(minX, maxY);

        this.p1 = g(newP1);
        this.p2 = g(newP2);
        this.p3 = g(newP3);
        this.p4 = g(newP4);
    }

    getClone() {
        var rect = new Rectangle(this.p1, this.p2, this.p3, this.p4, this.width, this.height, this.color, this.thickness);
        rect.rtype = this.rtype;
        // ********* обновление сохранённых вершин *********
        rect.saved = this.getVertices();
        return rect;
    }
    getDestructedClone() {

    }

    getBoundary() {
        return {
            p1: this.p1,
            p2: this.p2,
            p3: this.p3,
            p4: this.p4
        }

    }

    isinSelectFrame(frame) {
        if (
            isPointInsideFrame(frame, this.p1.x, this.p1.y) &&
            isPointInsideFrame(frame, this.p2.x, this.p2.y) &&
            isPointInsideFrame(frame, this.p3.x, this.p3.y) &&
            isPointInsideFrame(frame, this.p4.x, this.p4.y)
        ) {
            return true;
        }

        return false;
    }
    iscrossSelectFrame(frame) {
        // Validate frame before proceeding
        if (!frame || !frame.vec) {
            return false;
        }

        let vec1 = new Vector(this.p1, this.p2);
        let vec2 = new Vector(this.p2, this.p3);
        let vec3 = new Vector(this.p3, this.p4);
        let vec4 = new Vector(this.p4, this.p1);

        let vecs = [vec1, vec2, vec3, vec4];

        for (const v of vecs) {

            let xcross1 = findLinesIntersection(v, frame.vec.getOrtho1X());
            let ycross1 = findLinesIntersection(v, frame.vec.getOrtho1Y());
            let xcross2 = findLinesIntersection(v, frame.vec.getOrtho2X());
            let ycross2 = findLinesIntersection(v, frame.vec.getOrtho2Y());

            if (xcross1 || ycross1 || xcross2 || ycross2 || this.isinSelectFrame(frame)) {
                return true;
            }

        }

        return false;

    }

    isinSelectFrameAtLeast(frame) {
        // Validate frame before proceeding
        if (!frame || !frame.point1 || !frame.point2 || !frame.point3) {
            return false;
        }
        
        if (
            isPointInsideFrame(frame, this.p1.x, this.p1.y) ||
            isPointInsideFrame(frame, this.p2.x, this.p2.y) ||
            isPointInsideFrame(frame, this.p3.x, this.p3.y) ||
            isPointInsideFrame(frame, this.p4.x, this.p4.y)
        ) {
            return true;
        }

        return false;
    }


    isinSelectBoundary(mouse) {
        const isinTop = isinSelectBoundaryLine(mouse, this.p1, this.p2);
        const isinRight = isinSelectBoundaryLine(mouse, this.p2, this.p3);
        const isinBottom = isinSelectBoundaryLine(mouse, this.p4, this.p3);
        const isinLeft = isinSelectBoundaryLine(mouse, this.p1, this.p4);


        if (isinTop || isinBottom || isinRight || isinLeft) {
            return true;
        }
        return false;
    }

    setSelectBoundary() {
        this.selectBoundary = getSelectBoundaryRectangle(this.p1, this.p2, this.p3, this.p4);
    }

    // --------- MAGNETS ---------
    isinGripP1 = (mouse) => this.grip.isin(this.p1, mouse);
    isinGripP2 = (mouse) => this.grip.isin(this.p2, mouse);
    isinGripP3 = (mouse) => this.grip.isin(this.p3, mouse);
    isinGripP4 = (mouse) => this.grip.isin(this.p4, mouse);
    isinGripM1 = (mouse) => this.grip.isin(this.m1, mouse);
    isinGripM2 = (mouse) => this.grip.isin(this.m2, mouse);
    isinGripM3 = (mouse) => this.grip.isin(this.m3, mouse);
    isinGripM4 = (mouse) => this.grip.isin(this.m4, mouse);
    isinGripCenter = (mouse) => this.grip.isin(this.center, mouse);
    isinTripHtop = (mouse) => this.tripH.isin(this.m1, mouse);
    isinTripHbottom = (mouse) => this.tripH.isin(this.m3, mouse);
    isinTripVleft = (mouse) => this.tripV.isin(this.m4, mouse);
    isinTripVright = (mouse) => this.tripV.isin(this.m2, mouse);
    isinTripVMtop = (mouse) => this.tripV.isin(this.m1, mouse);
    isinTripVMbottom = (mouse) => this.tripV.isin(this.m3, mouse);
    isinTripHMright = (mouse) => this.tripH.isin(this.m2, mouse);
    isinTripHMleft = (mouse) => this.tripH.isin(this.m4, mouse);
    // --------- MAGNETS ---------

    zoom(zl) {
        const zoom_mat = mat3.fromScaling(mat3.create(), new Float32Array([zl, zl, 1]));
        this.p1 = transformPointByMatrix3(zoom_mat, this.p1);
        this.p2 = transformPointByMatrix3(zoom_mat, this.p2);
        this.p3 = transformPointByMatrix3(zoom_mat, this.p3);
        this.p4 = transformPointByMatrix3(zoom_mat, this.p4);
        this.width = this.width * zl;
        this.height = this.height * zl;
        this.updateCenter();
    }

    pan(tx, ty) {
        const pan_mat = mat3.fromTranslation(mat3.create(), new Float32Array([tx, ty, 0]));
        mat3.transpose(pan_mat, pan_mat);
        this.p1 = transformPointByMatrix3(pan_mat, this.p1);
        this.p2 = transformPointByMatrix3(pan_mat, this.p2);
        this.p3 = transformPointByMatrix3(pan_mat, this.p3);
        this.p4 = transformPointByMatrix3(pan_mat, this.p4);
        this.updateCenter();
    }

    updateWidthHeight() {
        this.width = Math.abs(this.p2.x - this.p1.x);
        this.height = Math.abs(this.p3.y - this.p1.y);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }

    /**
     * Функция возвращает 4 линии прямоугольника
     */
    getLines() {

        return [
            new Line(this.p1, this.p2, this.color, this.thickness),
            new Line(this.p2, this.p3, this.color, this.thickness),
            new Line(this.p3, this.p4, this.color, this.thickness),
            new Line(this.p4, this.p1, this.color, this.thickness),
        ];
    }
    getGuides() {

        return [
            new Line(this.p1, this.p2, s.guideColor, this.thickness),
            new Line(this.p2, this.p3, s.guideColor, this.thickness),
            new Line(this.p3, this.p4, s.guideColor, this.thickness),
            new Line(this.p4, this.p1, s.guideColor, this.thickness),
        ];
    }

    getPoints() {
        return [
            this.p1,
            this.p2,
            this.p3,
            this.p4,
        ];
    }

    public getCrucialPoints(): RouteCrucialPoints {
        /**
         * For network graph purposes, treat the rectangle as having two
         * main connection endpoints and an optional middle point.
         *
         * We use:
         * - start: top‑left corner (p1)
         * - end:   bottom‑right corner (p3)
         * - mid:   geometric center of the rectangle
         *
         * This is similar to how Line exposes its crucial points and allows
         * rectangles to participate in graph lookups via BasicShape.hasGraphNode().
         */
        const start = this.p1;
        const end = this.p3;
        const mid = this.center ?? getMid(this.p1, this.p3);

        return { start, end, mid };
    }

}